<div class="modal">
  <div class="modal-ctn">

    <div class="options">
      <input type="text" (keyup)="filterAnalyzers($event)">
      <img src="assets/images/close.svg" (click)="close()"/>
    </div>

    <div class="analyzers">
      @for (analyzer of displayedAnalyzers; track analyzer) {
        <div class="analyzer">
          <div class="logo">
            <div class="equipments">
              <img src="assets/images/analyzer.png"/>
            </div>
            <a>{{ analyzer.analyzerId }}</a>
          </div>
          <div class="info">
            <a>{{ 'MATERIAL.ANALYZER.MODEL' | translate }}: {{ analyzer.analyzermodelName }}</a>
            <a>{{ 'MATERIAL.ANALYZER.RANGE' | translate }}: {{ analyzer.analyzermodelGas }}</a>
            <a>{{ 'MATERIAL.TELEMETRY' | translate }}: {{ analyzer.telemetrysuppliername }}</a>
            <a>{{ analyzer.exatmregulation }}: {{ analyzer.exatmclasse }}</a>
          </div>
          <div class="add" (click)="addAnalyzer(analyzer)">
            <img src="assets/images/add-shopping-cart.svg"/>
          </div>
        </div>
      }
    </div>

  </div>
</div>